import { useTranslations } from '@vocab/react';
import {
  Box,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import translations from './.vocab';
import { AdPerformance } from './images/AdPerformanceSvg';
import { SaveMoney } from './images/SaveMoneySvg';
import { SaveTime } from './images/SaveTimeSvg';
import { Success } from './images/SuccessSvg';

import * as styles from './AdBudgetValueProposition.css';

interface Props {
  icon: JSX.Element;
  title: string;
  text: string;
}

const IconContentBox = ({ icon, title: heading, text }: Props) => (
  <Column>
    <Box className={styles.root}>
      <Stack space="medium">
        <Box className={styles.image}>{icon}</Box>
        <Stack space="small">
          <Text tone="neutral" weight="medium" size="large">
            {heading}
          </Text>
          <Text tone="neutral">{text}</Text>
        </Stack>
      </Stack>
    </Box>
  </Column>
);

const AdBudgetValueProposition = ({
  selectedBudgetType,
}: {
  selectedBudgetType: string;
}) => {
  const { t } = useTranslations(translations);

  const ValuePropositions: Props[] = [
    {
      icon: <SaveMoney />,
      title: t('get discounts'),
      text: t('save money each time you...'),
    },
    {
      icon: <SaveTime />,
      title: t('save time'),
      text: t('pay once then post ads...'),
    },
  ];
  if (selectedBudgetType === 'PremiumBudget') {
    ValuePropositions.push({
      icon: <AdPerformance />,
      title: t('better performance'),
      text: t('reach more job seekers...'),
    });
  } else {
    ValuePropositions.push({
      icon: <Success />,
      title: t('keep saving'),
      text: t('post ads at a discount...'),
    });
  }

  return (
    <Stack space="xlarge">
      <Heading align="center" level="2">
        {t('enjoy better value when...')}
      </Heading>
      <Columns
        collapseBelow="tablet"
        space={{ desktop: 'small', mobile: 'xxlarge' }}
      >
        {ValuePropositions.map(({ icon, title, text }) => (
          <IconContentBox key={title} icon={icon} title={title} text={text} />
        ))}
      </Columns>
    </Stack>
  );
};

export { AdBudgetValueProposition };
